// component
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------
// Ikonice iz Material Design Icons (mdi) preko Iconify komponente iz templatea.
// Boja se preuzima iz teme: obične stavke su smeđe-sive, aktivna stavka smeđa.
// Pregled svih ikonica: https://icon-sets.iconify.design/mdi/

const icon = (name) => <Iconify icon={name} width={22} />;

const navConfig = [
  {
    title: 'Pregled',
    path: '/dashboard/app',
    icon: icon('mdi:view-dashboard-outline'),
  },
  {
    title: 'Evidencija korisnika',
    path: '/dashboard/HuntersReportAll',
    icon: icon('mdi:account-group-outline'),
  },
  {
    title: 'Evidencija uređaja',
    path: '/dashboard/DogsReportAll',
    icon: icon('mdi:dog-side'),
  },
  {
    title: 'Dijeljeni uređaji',
    path: '/dashboard/SharedDevices',
    icon: icon('mdi:share-variant-outline'),
  },
  {
    title: 'Nedodijeljeni uređaji',
    path: '/dashboard/UnassociatedDevices',
    icon: icon('mdi:link-variant-off'),
  },
  {
    title: 'Online',
    path: '/dashboard/OnlineDevices',
    icon: icon('mdi:access-point'),
  },
  {
    title: 'History',
    path: '/dashboard/HistoryHuntersDevicesAll',
    icon: icon('mdi:history'),
  },
  {
    title: 'Nevažeći vaučeri',
    path: '/dashboard/UnpaidDevices',
    icon: icon('mdi:cash-remove'),
  },
  {
    title: 'Mapa',
    path: '/dashboard/Mapa',
    icon: icon('mdi:map-outline'),
  },
  {
    title: 'Mapa Live',
    path: '/dashboard/MapaLive',
    icon: icon('mdi:map-marker-radius-outline'),
  },
  {
    title: 'Mapa Live Multiple',
    path: '/dashboard/MapaLiveMultiple',
    icon: icon('mdi:map-marker-multiple-outline'),
  },
  {
    title: 'Mapa Live Multiple Analyse',
    path: '/dashboard/MapaLiveMultipleAnalyse',
    icon: icon('mdi:map-search-outline'),
  },
  {
    title: 'Uplate',
    path: '/dashboard/Bills',
    icon: icon('mdi:cash-multiple'),
  },
];

export default navConfig;